<form>
  <app-dados-boleta
    titulo="Dados da Boleta - Renda Variável"
    operationDate="2019/07/11"
  >
  </app-dados-boleta>

  <div class="card mt-3">
    <div class="card-header text-uppercase">Dados da Carteira / Fundo</div>
    <div class="card-body">
      <div>
        <label>Nome do Fundo</label>
        <input
          type="text"
          class="form-control"
          name="portfolioName"
          required
          maxlength="90"
          pattern="[0-9a-zA-Z\u00C0-\u00D6\u00D9-\u00DC\u00E0-\u00fc\s]*"
        />
      </div>
      <div class="row mb-2">
        <div class="col-6">
          <label>CNPJ</label>
          <input
            type="text"
            class="form-control"
            name="portfolioDocument"
            #portfolioDocument
            pattern="\d{2}[.]\d{3}[.]\d{3}\/\d{4}-\d{2}"
            [textMask]="{
              mask: validator.documentLegalPersonMask,
              guide: false
            }"
          />
        </div>
        <div class="col-6">
          <label>Banco</label>
          <input type="text" class="form-control" />
        </div>
      </div>
      <div class="row mb-2">
        <div class="col-4">
          <label>Agência</label>
          <input type="text" class="form-control" />
        </div>
        <div class="col-4">
          <label>Conta Corrente</label>
          <input
            data-cy="portfolioAccount"
            type="text"
            class="form-control"
            name="portfolioAccount"
            maxlength="10"
            required
            pattern="\w+-?\w*"
          />
        </div>
        <div class="col-4">
          <label>Código B3</label>
          <input type="text" class="form-control" />
        </div>
      </div>
    </div>
  </div>
  <div class="card mt-3">
    <div class="card-header text-uppercase">Dados da Operação</div>
    <div class="card-body">
      <div class="row mb-2">
        <div class="col-6">
          <label>Corretora</label>
          <input type="text" class="form-control" />
        </div>
        <div class="col-6">
          <label>Data do Pregão</label>
          <input
            #tradingDate
            name="tradingDate"
            type="text"
            class="form-control"
            [textMask]="{ mask: validator.dateMask, guide: false }"
          />
        </div>
      </div>

      <div class="row mb-2">
        <div class="col-4">
          <label>Tipo de Mercado</label>
          <div>
            <div class="form-check form-check-inline">
              <input
                class="form-check-input"
                type="radio"
                id="typeAction"
                name="typeAction"
                [value]="1"
                [(ngModel)]="typeAction"
              />
              <label class="form-check-label">À Vista</label>
            </div>
            <div class="form-check form-check-inline">
              <input
                class="form-check-input"
                type="radio"
                id="typeAction"
                name="typeAction"
                [value]="2"
                [(ngModel)]="typeAction"
              />
              <label class="form-check-label">Termo</label>
            </div>
            <div class="form-check form-check-inline">
              <input
                class="form-check-input"
                type="radio"
                id="typeAction"
                name="typeAction"
                [value]="3"
                [(ngModel)]="typeAction"
              />
              <label class="form-check-label">Opções</label>
            </div>
          </div>
        </div>
        <div class="col-4">
          <label>Modo de Operação</label>
          <div>
            <div class="form-check form-check-inline">
              <input
                class="form-check-input"
                type="radio"
                id="operationMode"
                name="operationMode"
                [value]="1"
                [(ngModel)]="operationMode"
              />
              <label class="form-check-label">Compra</label>
            </div>
            <div class="form-check form-check-inline">
              <input
                class="form-check-input"
                type="radio"
                id="operationMode"
                name="operationMode"
                [value]="2"
                [(ngModel)]="operationMode"
              />
              <label class="form-check-label">Venda</label>
            </div>
          </div>
        </div>
        <div class="col-4">
          <label>Tipo de Operação</label>
          <div>
            <div class="form-check form-check-inline">
              <input
                class="form-check-input"
                type="radio"
                id="operationMode"
                name="operationMode"
                [value]="1"
                [(ngModel)]="operationMode"
              />
              <label class="form-check-label">Operação Final</label>
            </div>
            <div class="form-check form-check-inline">
              <input
                class="form-check-input"
                type="radio"
                id="operationMode"
                name="operationMode"
                [value]="2"
                [(ngModel)]="operationMode"
              />
              <label class="form-check-label">Day Trade</label>
            </div>
          </div>
        </div>
      </div>

      <div class="row mb-2">
        <div class="col-4">
          <label>Código do Papel</label>
          <input type="text" class="form-control" />
        </div>
        <div class="col-4">
          <label>Quantidade</label>
          <input type="text" class="form-control" />
        </div>
        <div class="col-4">
          <label>Preço</label>
          <input type="text" class="form-control" />
        </div>
      </div>

      <div class="row mb-2">
        <div class="col-4">
          <label>Valor do Contrato</label>
          <input type="text" class="form-control" />
        </div>
        <div class="col-4">
          <label>Valor Liquido</label>
          <input type="text" class="form-control" />
        </div>
        <div class="col-4">
          <label>Percentual de Desconto</label>
          <input type="text" class="form-control" />
        </div>
      </div>

      <br />
      <div>
        <label>Observações</label>
        <textarea
          data-cy="annotations"
          class="form-control"
          rows="5"
          name="annotations"
          maxlength="200"
        ></textarea>
      </div>

      <div class="actions">
        <input
          data-cy="submit"
          type="button"
          value="Salvar"
          class="btn btn-primary me-2"
        />
        <input
          type="button"
          data-cy="forward"
          value="Encaminhar"
          class="btn btn-primary me-2"
        />
      </div>
    </div>
  </div>
</form>
